module.exports = __webpack_public_path__ + "img/anklecircumference.e3b12422.jpeg";